import i18n from '../i18n';

const localeMap = {
  fr: 'fr-FR',
  en: 'en-GB',
  de: 'de-DE',
  zh: 'zh-CN'
};

export function getLocale() {
  return localeMap[i18n.language] || localeMap[i18n.language?.split('-')[0]] || 'fr-FR';
}

export function formatDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString(getLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

export function formatDateTime(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString(getLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatShortDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString(getLocale(), {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
}
